export const secrets = { risKey: "Ic7sP4GDitSjMeR8iZ0OO-VqX6nmrXYXZKmYUYxotchdAzFue1kIvw==" };
